/*=========================================================================================
  File Name: analyticsData.vue
  Description: Data shown by charts

==========================================================================================*/

function generatePreviousDate (days) {
  const result = new Date()
  result.setDate(result.getDate() - days)
  return `${result.toLocaleString('default', { month: 'short' })} ${result.getDate()}`
}

export default {
  totalSimulationsPie: {
    chartOptions: {
      labels: ['Not Started', 'Started', 'Completed'],
      dataLabels: {
        enabled: false
      },
      legend: {show: false},
      chart: {
        type: 'pie',
        offsetY: 0,
        dropShadow: {
          enabled: false,
          blur: 5,
          left: 1,
          top: 1,
          opacity: 0.2
        },
        toolbar: {
          show: false
        }
      },
      stroke: {
        width: 5
      },
      colors: ['#fd4445', '#FF9F43', '#28C76F'],
      fill: {
        type: 'gradient',
        gradient: {
          gradientToColors: ['#f29292', '#FFC085', '#55DD92']
        }
      }
    }
  },
  simulationsLineChartDaily: {
    chartOptions: {
      chart: {
        height: 400,
        zoom: {
          enabled: false
        }
      },
      colors: ['#FF9F43', '#0cdc62'],
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      grid: {
        row: {
          colors: ['#f3f3f340', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      xaxis: {
        categories: [
          generatePreviousDate(8),
          generatePreviousDate(7),
          generatePreviousDate(6),
          generatePreviousDate(5),
          generatePreviousDate(4),
          generatePreviousDate(3),
          generatePreviousDate(2),
          generatePreviousDate(1),
          generatePreviousDate(0)
        ]
      }
    }
  },
  timeLineChartDaily: {
    chartOptions: {
      chart: {
        height: 400,
        zoom: {
          enabled: false
        }
      },
      colors: ['#00B5FF'],
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      grid: {
        row: {
          colors: ['#f3f3f340', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      xaxis: {
        categories: [
          generatePreviousDate(8),
          generatePreviousDate(7),
          generatePreviousDate(6),
          generatePreviousDate(5),
          generatePreviousDate(4),
          generatePreviousDate(3),
          generatePreviousDate(2),
          generatePreviousDate(1),
          generatePreviousDate(0)
        ]
      }
    }
  }
}
